export const getMinSuggestChars = 3;
